import Button from '@anm/components/buttons/Button';
import { FC, MouseEvent } from 'react';

import Badge from '../Badge';

import DiscountContentWrapper, { AffSectionTitle } from './Wrapper';

type DiscountContentProps = {
  onOk?: () => void;
  onCancel?: ((event: MouseEvent<Element>) => void) | undefined;
};
const DiscountContent: FC<DiscountContentProps> = ({ onOk, onCancel }) => (
  <DiscountContentWrapper>
    <Badge>
      Best <br /> deal
    </Badge>

    <AffSectionTitle color="white" title="Special offer for you!" />
    <p>You've come from our friends and we have a present for you!</p>
    <p>
      Sign up now and get 10% off when you upgrade to any paid plan. Or use any of our current offers if it makes a
      greater deal for you.
    </p>

    <Button size="big" variant="yellow" onClick={onOk}>
      Take the offer
    </Button>
    <Button size="big" variant="simple-light-blue-underlined" onClick={onCancel}>
      No, thanks
    </Button>
  </DiscountContentWrapper>
);

export default DiscountContent;
